import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { getStyles } from './styles';
import { CourseListItem } from '@beable/roster-backend-client-v1';
import { CircularProgress } from '@mui/material';
import dataViewService from '../../services/DataViewService';

interface CoursesTableProps {
  siteId: number;
  schoolId: string;
  onCourseSelect: any;
}

export default function CoursesTable(props: CoursesTableProps) {
  const theme = useTheme();
  const styles = getStyles(theme);

  const [isLoading, setIsLoading] = useState(false);
  const [courses, setCourses] = useState<CourseListItem[]>([]);
  const [selectedCourse, setSelectedCourse] = useState<CourseListItem | undefined>(undefined);

  useEffect(() => {
    const fetchCourses = async () => {
      setIsLoading(true);

      const fetchedCourses = await dataViewService.getCoursesForSchool(props.schoolId, props.siteId);

      setIsLoading(false);
      if(fetchedCourses) {
        setCourses(fetchedCourses);
      } else {
        setCourses([]);
        alert("Could not get the courses. Please contact support...");
      }
    }

    fetchCourses();
  }, [props.schoolId, props.siteId])

  const handleCourseSelect = async (course: CourseListItem) => {
    setSelectedCourse(course);
    props.onCourseSelect(course.id)
  }

  return (
    <Box sx={styles.courses_root}>
      {isLoading ?
              <Box sx={styles.loaderContainer}>
                  <CircularProgress disableShrink />
              </Box> :
              null}
      <Table size="small" aria-label="courses table">
        <TableHead>
          <TableRow>
            <TableCell>Course</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Grades</TableCell>
            <TableCell>Classes</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!isLoading && courses && courses.map((course: CourseListItem) => {
              return(<TableRow
                        selected={selectedCourse && selectedCourse.id === course.id}
                        key={course.id}
                        sx={styles.clickable}
                        onClick={() => {handleCourseSelect(course)}}>
                  <TableCell>{course.name}</TableCell>
                  <TableCell>{course.internalStatus}</TableCell>
                  <TableCell>{course.grade ? course.grade : ''}</TableCell>
                  <TableCell>{course.numberOfClasses ? course.numberOfClasses : 0}</TableCell>
              </TableRow>)
          })}
        </TableBody>
      </Table>
    </Box>
  );
}
